const getTokenLogoURL = (address: string) =>
  `/thbm/images/tokens/${address}.png`

export default getTokenLogoURL
